var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorVerificationNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5489_28505)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5489_28505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9058 79.3489H37.7198C36.7927 79.3489 35.9569 79.9074 35.6022 80.7639C35.2475 81.6204 35.4436 82.6063 36.0992 83.2619L53.2851 100.448C53.9406 101.103 54.9266 101.299 55.7831 100.945C56.6396 100.59 57.1981 99.754 57.1981 98.8271V81.641C57.1979 80.3751 56.1717 79.3489 54.9058 79.3489V79.3489Z",
    fill: "#C4CDD5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.8224 101.119H54.9058C53.6399 101.119 52.6137 100.093 52.6137 98.8268V86.2251C52.6137 84.9593 51.5874 83.933 50.3215 83.933H37.7199C36.454 83.933 35.4277 82.9067 35.4277 81.6409V25.173C35.4277 23.9071 36.454 22.8809 37.7199 22.8809H86.8224C88.0882 22.8809 89.1145 23.9071 89.1145 25.173V98.8268C89.1145 100.093 88.0882 101.119 86.8224 101.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.2107,
    height: 1.65722,
    rx: 0.82861,
    transform: "matrix(1 -3.38451e-08 -2.64016e-06 1 55.459 43.7375)",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.0785,
    height: 1.65722,
    rx: 0.82861,
    transform: "matrix(1 -3.38451e-08 -2.64016e-06 1 55.3691 47.2761)",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2852 44.0713C44.2852 42.9667 45.1806 42.0713 46.2852 42.0713H51.1423C52.2469 42.0713 53.1423 42.9667 53.1423 44.0713L53.1423 48.9284C53.1423 50.033 52.2468 50.9284 51.1423 50.9284H46.2851C45.1806 50.9284 44.2851 50.033 44.2851 48.9284L44.2852 44.0713Z",
    fill: "#FBE0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0435 38.3809L49.8857 45.0414H48.2606L48.0318 38.3809H50.0435ZM47.9766 46.9405C47.9766 46.6497 48.0712 46.4066 48.2606 46.211C48.4552 46.0101 48.7234 45.9097 49.0652 45.9097C49.4018 45.9097 49.6674 46.0101 49.862 46.211C50.0566 46.4066 50.1539 46.6497 50.1539 46.9405C50.1539 47.2206 50.0566 47.4611 49.862 47.662C49.6674 47.8576 49.4018 47.9554 49.0652 47.9554C48.7234 47.9554 48.4552 47.8576 48.2606 47.662C48.0712 47.4611 47.9766 47.2206 47.9766 46.9405Z",
    fill: "#F5A342"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.2107,
    height: 1.65722,
    rx: 0.82861,
    transform: "matrix(1 -3.38451e-08 -2.64016e-06 1 55.459 55.5471)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.0785,
    height: 1.65722,
    rx: 0.82861,
    transform: "matrix(1 -3.38451e-08 -2.64016e-06 1 55.3691 59.0857)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.85714,
    height: 8.85714,
    rx: 2,
    transform: "matrix(1 0 -2.60632e-06 1 44.2852 53.8809)",
    fill: "url(#paint0_linear_5489_28505)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.2107,
    height: 1.65722,
    rx: 0.82861,
    transform: "matrix(1 -3.38451e-08 -2.64016e-06 1 55.459 67.3567)",
    fill: "#C9D1DA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.0785,
    height: 1.65722,
    rx: 0.82861,
    transform: "matrix(1 -3.38451e-08 -2.64016e-06 1 55.3691 70.8953)",
    fill: "#C9D1DA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.85714,
    height: 8.85714,
    rx: 2,
    transform: "matrix(1 0 -2.60632e-06 1 44.2852 65.6904)",
    fill: "url(#paint1_linear_5489_28505)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5489_28505",
    x: 19.4277,
    y: 12.8809,
    width: 77.6875,
    height: 102.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5489_28505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5489_28505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5489_28505",
    x: 23.2997,
    y: 65.0806,
    width: 46.0257,
    height: 46.0264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.14025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06403
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5489_28505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5489_28505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5489_28505",
    x1: 4.60266,
    y1: 8.67199,
    x2: 3.89547,
    y2: 0.184152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5489_28505",
    x1: 4.60266,
    y1: 8.67199,
    x2: 3.89547,
    y2: 0.184152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorVerificationNeeded);
export default __webpack_public_path__ + "static/media/InvestorVerificationNeeded.87a86bf4783073b52f4ae7444eb64851.svg";
export { ForwardRef as ReactComponent };